export default __webpack_public_path__ + "static/media/MortgageLoan.1bd1bf6b.svg";